<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>
<script>
export default {
    created() {}
}
</script>
<style lang="less">
body {
  font-size: 0.16rem;
  margin: 0 auto !important;
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}
</style>